module.exports = __webpack_public_path__ + "img/purpleheart-mask.4d87e887.png";